import React from 'react';
import { useNavigate } from 'react-router-dom';
import './Welcome.css';
import Section from "../../../../components/Clientes/Section/Section";
import {ReactComponent as CheckIcon} from "../../../../assets/systemIcons/ic_checked.svg";
import {ReactComponent as Arrow} from "../../../../assets/systemIcons/rigth_arrow.svg";
import { trackClick, getElementName } from "../../../../utils/analytics/analytics";
import { ANALYTICS_MODULES, ANALYTICS_SECTIONS, ANALYTICS_ELEMENT_TYPES } from "../../../../constants/analyticsConstants";

function Welcome() {
    const navigate = useNavigate();

    return (
        <Section>
            <div className="clientes__welcome__container">
                <div className="clientes__welcome__bodyContainer">
                    <h1 className="clientes__welcome__title">Cotizá tu seguro<br/>en segundos</h1>
                    <h2 className="clientes__welcome__description">Te conectamos con los mejores productores del
                        país.</h2>
                    <ul className="clientes__welcome__list">
                        <li>
                            <CheckIcon className="clientes__welcome__icon"/>
                            Pagos protegidos
                        </li>
                        <li>
                            <CheckIcon className="clientes__welcome__icon"/>
                            Cobertura a medida
                        </li>
                        <li>
                            <CheckIcon className="clientes__welcome__icon"/>
                            Profesionales matriculados
                        </li>
                    </ul>
                    <button
                        className="clientes__welcome__button"
                        onClick={() => {
                            trackClick({
                                module: ANALYTICS_MODULES.LANDING,
                                section: ANALYTICS_SECTIONS.LANDING_WELCOME,
                                elementName: getElementName(ANALYTICS_ELEMENT_TYPES.BUTTON, ANALYTICS_SECTIONS.LANDING_WELCOME, 'comenzar_ahora'),
                                elementType: ANALYTICS_ELEMENT_TYPES.BUTTON
                            });
                            navigate("/productos");
                        }}
                    >
                        <p className="clientes__welcome__buttonText">Comenzar ahora</p>
                        <Arrow className="clientes__welcome__buttonArrow"/>
                    </button>
                </div>
                <div className="clientes__welcome__imgContainer">
                    <img
                        src="https://polko-images.s3.us-east-2.amazonaws.com/polko-clients/sections/welcome.webp"
                        alt="Welcome"
                    />
                </div>
            </div>
        </Section>
    );
}

export default Welcome;